import { FC } from 'react';
import { Box, ListItem, UnorderedList } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import locales from './locales';

interface Props {
  errorMessages: string[];
}

const ErrorDetailsBox: FC<Props> = ({ errorMessages }) => (
  <Box bg="red.4" borderRadius="radius-8" padding="space-16">
    <Text color="red.-1" fontWeight="weight-500" size="sm" variant="primary">
      {locales.title}
    </Text>
    <UnorderedList color="red.-2" marginBottom="space-16" marginTop="space-8">
      {errorMessages.map((errorMessage) => (
        <ListItem key={errorMessage}>
          <Text color="red.-1" size="sm" variant="primary">
            {errorMessage}
          </Text>
        </ListItem>
      ))}
    </UnorderedList>
    <Text color="red.-1" size="sm" variant="primary">
      {locales.helpText}
    </Text>
  </Box>
);

export default ErrorDetailsBox;
